/**
 * Shopify Inbox-chatten vs temats popuper och fasta köpbarer (se assets/custom-chat.css).
 *
 * 1. Hittar chattens värdelement (direkt barn till <body> vars tagg, id eller klass innehåller "chat" eller
 *    "inbox"), också när det läggs till senare, och markerar det med .theme-chat-host + isolation:isolate.
 * 2. Döljer chatten (html.theme-chat-hidden) medan en fast köpbar ligger i chattens hörn nere till höger, så att
 *    chattknappen aldrig täcker köpknappen:
 *    - Mix & Match-baren (sections/Bundle.liquid)
 *    - varukorgssidans kassabar på mobilen (sections/checkout-cart.liquid)
 *    - produktsidans köpbar (<product-quick-add>)
 *    Att lyfta knappen gick inte att lita på: Inbox ritar den i en shadow DOM med egen fast position, så den
 *    stod kvar över köpknappen. På breda skärmar där baren slutar före hörnet syns chatten som vanligt.
 * 3. Produktsidans köpbar sätter samma klass och höjd som de andra barerna (html.has-bundle-sticky och
 *    --bundle-sticky-height), som varukorgsbekräftelsen använder för att hamna ovanför baren.
 */
(function () {
  if (window.__themeChatInit) return;
  window.__themeChatInit = true;

  var NAME_RE = /chat|inbox/i;
  var SKIP_RE = /^(script|style|link|template|noscript)$/i;
  var OWN_RE = /^(cart-|quick-buy|product-|navigation-|store-header|height-observer|x-)/i;
  var BARS = 'product-quick-add.is-visible, [data-cc-sticky].is-visible, [data-bundle-sticky]';
  // Chattknappens hörn: Inbox lägger knappen nere till höger, inom så här många px från kanterna
  var CORNER = 100;

  function isCandidate(el) {
    if (!el || el.nodeType !== 1 || el.parentElement !== document.body) return false;
    if (SKIP_RE.test(el.tagName) || OWN_RE.test(el.tagName)) return false;
    var cls = typeof el.className === 'string' ? el.className : '';
    return NAME_RE.test(el.tagName) || NAME_RE.test(el.id || '') || NAME_RE.test(cls);
  }

  function mark(el) {
    if (el.classList.contains('theme-chat-host')) return;
    el.classList.add('theme-chat-host');
    el.style.setProperty('isolation', 'isolate', 'important');
    if (getComputedStyle(el).position !== 'static') {
      el.style.setProperty('z-index', '900', 'important');
    }
  }

  function scan() {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (isCandidate(el)) mark(el);
    });
  }

  // Ligger en synlig köpbar i chattens hörn?
  function barInCorner() {
    if (!document.documentElement.classList.contains('has-bundle-sticky')) return false;
    return Array.prototype.some.call(document.querySelectorAll(BARS), function (bar) {
      var rect = bar.getBoundingClientRect();
      return rect.height > 0 && rect.right > window.innerWidth - CORNER && rect.bottom > window.innerHeight - CORNER;
    });
  }

  function update() {
    // Ändras inget görs ingen ändring på <html>, så klassobservatören nedan går inte i loop
    document.documentElement.classList.toggle('theme-chat-hidden', barInCorner());
  }

  var queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      update();
    });
  }

  function watchQuickAdd() {
    var bar = document.querySelector('product-quick-add');
    if (!bar) return;
    var root = document.documentElement;

    function sync() {
      var visible = bar.classList.contains('is-visible');
      if (visible) {
        // Avstånd från skärmens underkant till barens överkant (baren är ett kort nere till höger på datorn)
        var lift = Math.max(0, Math.round(window.innerHeight - bar.getBoundingClientRect().top));
        root.style.setProperty('--bundle-sticky-height', lift + 'px');
      }
      root.classList.toggle('has-bundle-sticky', visible);
    }

    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync);
    sync();
  }

  function start() {
    watchQuickAdd();
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true });
    // Barerna visas och döljs med klassen på <html>. Mix & Match-baren släpper botten när kunden når sista raden,
    // därför räknas läget om också vid scroll och storleksändring.
    new MutationObserver(queueUpdate).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    update();
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
